import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { apiURL } from '../../../utilities/URLs'
import { account } from '../../../classes/Account'
import { refreshAccessToken } from '../../../utilities/extensions'
import { Documents } from './classes/Documents'
import DocumentSection from './components/DocumentSection'

export default function DocumentsPage() {
  const { applicationId } = useParams()
  const navigate = useNavigate()

  const [documents, setDocuments] = useState([])

  useEffect(() => {
    const handleGetDocuments = async () => {
      const documentsResponse = await fetch(`${apiURL}/api/applications/${applicationId}/documents/get/`, {
        method: 'GET',
        headers: {
          'Authorization': account.accessToken
        }
      })
      const documentsData = await documentsResponse.json()
      if (documentsData.response.error) {
        if (documentsData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          refreshedToken && refreshedToken.length > 0 ? await handleGetDocuments() : navigate('/', { state: { expired: true } })
        } else
          console.error(documentsData.response.error)
      } else
        setDocuments(documentsData.response.documents)
    }

    handleGetDocuments()
  }, [])

  return (
    <div className='w-full flex flex-1 flex-col items-center bg-gray-50 dark:bg-slate-900 p-4 transition-colors'>
      <h1 className='text-2xl font-bold text-gray-900 dark:text-white mb-7 text-center w-full'>Documents</h1>
      {documents.map((_documents, index) => {
        const documents = new Documents(_documents)
        return (
          <DocumentSection
            key={index}
            title={documents.name}
            documents={documents.documents}
          />
        )
      })}
    </div>
  )
}